module.exports = __webpack_public_path__ + "static/media/histogramticks.fe5d5b89.svg";